export default __webpack_public_path__ + "images/961037a7ca6a9ee93d4b0ae0c16a3064.png";